module.exports = __webpack_public_path__ + "img/title_2.296738d8.png";